import styled, { css } from 'styled-components';
import { MultiValue } from 'react-select';

export interface IPanelOption {
  value: string;
  label: string;
}

export interface IGridPanelsProps {
  panelsList: MultiValue<IPanelOption>;
  isDisabled: boolean;
  storageName: string;
}

export const ACTIONS_BUTTONS_WRAPPER = {
  display: 'flex',
  justifyContent: 'space-between',
  margin: '5px',
};

export const IconStyled = styled.div<{ $isOpen: boolean }>`
  ${({ $isOpen }) =>
    $isOpen &&
    css`
      transform: rotate(180deg);
    `}

  padding-top: 5px;
`;
